var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "market-watch-container" },
    [
      _vm._l(_vm.watches, function(item) {
        return _c("div", { staticClass: "watch-item" }, [
          _c("h3", [_vm._v(_vm._s(item.Title))]),
          _vm._v(" "),
          _c("p", { staticClass: "date" }, [
            _vm._v(_vm._s(_vm.formatDate(item.Date)))
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "watch-copy",
            domProps: { innerHTML: _vm._s(item.Description) }
          }),
          _vm._v(" "),
          _c("ul", { staticClass: "watch-data" }, [
            _c("li", [
              _c("h4", [_vm._v("Activity")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(item.Activity))])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("h4", [_vm._v("Prices")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(item.Prices))])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("h4", [_vm._v("Trend")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(item.Trend))])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("h4", [_vm._v("Order Files")]),
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(item.OrderFiles))])
            ])
          ])
        ])
      }),
      _vm._v(" "),
      _vm.buttonShow
        ? _c(
            "button",
            {
              staticClass: "btn",
              on: {
                click: function($event) {
                  return _vm.addItems()
                }
              }
            },
            [_vm._v("View More")]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4775d789", { render: render, staticRenderFns: staticRenderFns })
  }
}